import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router";
import unsatLogo from "./images/unsat_logo.png";
import syllabus from "./images/syllabus.png";
import trophy from "./images/trophy.png";
import { AppPropertiesContext } from "../../contexts/app-properties.context";
import ApiService from "../../_services/ApiService";
import { ILoader } from "../../_components/iloader/iloader";
import { Row, Container } from "react-bootstrap";
import "./unsat-landing.styles.css";

const UnsatLanding = () => {
  const [admissionDetails, setAdmissionDetails] = useState({});
  const { registrationForms } = useContext(AppPropertiesContext);
  const [testDetails, setTestDetails] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const [showMailSentBox, setShowMailSentBox] = useState(false);
  const currentRegistrationForm = registrationForms[0];

  const mode = "result";

  let commingSoonTimeOuts = [];

  const history = useHistory();

  const fetchAdmitCardDetails = async () => {
    try {
      const res = await ApiService.fetchAdmitCardDetails();
      const admissionDetails = res.data;
      setAdmissionDetails(admissionDetails);
    } catch (err) {
      console.log(err);
    }
  };

  const dateStringToUnix = (date) => {
    if (!date || date === "--") return;
    // require date format is dd/mm/yy hr:min (AM/PM)
    const [dateString, time, meridiemIndicator] = date?.split(" ");

    let finalTime = time;

    if (meridiemIndicator === "PM" && Number(finalTime.split(":")[0]) !== 12) {
      finalTime = `${Number(finalTime.split(":")[0]) + 12}:${
        finalTime.split(":")[1]
      }`;
    }

    const splitedDate = dateString.split("/");

    const finalDate = `${splitedDate[1]}-${splitedDate[0]}-${splitedDate[2]}`;

    const udate = new Date(`${finalDate} ${finalTime}`).getTime();
    if (!isNaN(udate)) {
      var unixDate = udate;
    } else {
      //get month
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      var month = monthNames[splitedDate[1] - 1];
      var unixDate = new Date(
        `${month} ${splitedDate[0]} ${splitedDate[2]}  ${finalTime}`
      ).getTime();
    }
    return unixDate;
  };

  const changeToStartTest = (testIndex, interval) => {
    if (interval < -1) return;
    if (interval > 2147483647) return;
    const currentTimeOut = setTimeout(() => {
      setTestDetails((testDetails) => {
        console.log("running", "here");
        const existingTestData = [...testDetails];

        existingTestData[testIndex].status = "Launch";

        console.log(existingTestData);

        return existingTestData;
      });
    }, interval);

    commingSoonTimeOuts.push(currentTimeOut);
  };

  const scanTest = async (testDataBeans) => {
    if (!testDataBeans.length) return;

    const currentTime = await ApiService.fetchCurrentTime();

    testDataBeans.forEach(async (test, index) => {
      if (test.status === "Coming Soon") {
        console.log(test, "here");
        const testTimeInUnix = dateStringToUnix(test.startDate);
        changeToStartTest(index, testTimeInUnix - currentTime.unix_time * 1000);
      }
    });
  };

  useEffect(() => {
    return () => {
      commingSoonTimeOuts.forEach((timeOut) => {
        clearTimeout(timeOut);
      });
    };
  }, []);

  const showRequestChange = (testTime) => {
    const currentTime = new Date().getTime();
    const testTimeInUnix = dateStringToUnix(testTime);

    if (testTimeInUnix - currentTime < 259200000) {
      return false;
    }

    return mode !== "result";
  };

  const fetchTestDetails = async () => {
    try {
      const response = await ApiService.fetchTestList();
      const TestData = response.data[0]?.categoryBeans[0]?.testDataBeans;
      console.log(TestData);
      setTestDetails(TestData);
      scanTest(TestData);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchAllTest = async () => {
    const testDetails = await ApiService.fetchAllTest();
    const TestData = testDetails.data?.data?.courses[0]?.categories[0]?.tests;
    console.log(TestData);
    setTestDetails(TestData);
  };

  useEffect(() => {
    const fetchAllData = async () => {
      setShowLoader(true);
      await Promise.all([
        mode === "result" ? fetchAllTest() : fetchTestDetails(),
        fetchAdmitCardDetails(),
      ]);
      setShowLoader(false);
    };

    fetchAllData();
  }, []);

  const { jsonField1 } = admissionDetails;

  const getValueForDropdown = (
    formDetails,
    optionsKey,
    userDetails,
    detailId
  ) => {
    if (!formDetails || !userDetails) return null;
    const details = formDetails[optionsKey]?.find(
      (option) => option.id?.toString() === userDetails[detailId]?.toString()
    )?.display;

    return details || null;
  };

  const logout = () => {
    history.push({
      pathname: "/logout",
      state: { redirectRoute: "/loginwithmobile" },
    });
  };

  const openSyllabus = () => {
    window.open(
      "https://tuningfork-live.s3.ap-southeast-1.amazonaws.com/unsat/extras/UNSAT+Syllabus.pdf"
    );
  };

  const handleRequestChange = async (whatToChange) => {
    setShowMailSentBox(false);
    const body = {
      subject: "Change Request",
      message: `${jsonField1.mobileNumber}/${jsonField1.email} want to change ${whatToChange}`,
      emailIds: ["unsat@unacademy.com"],
    };

    console.log(body);
    try {
      const res = await ApiService.sendEmail(body);
      console.log(res);
      setShowMailSentBox(true);
    } catch (err) {
      console.log(err);
    }
  };

  const openTest = (testId) => {
    window.open(
      `/TestInstructions/${testId}`,
      "Start Test",
      "height=" + window.screen.height + ",width=" + window.screen.width
    );
  };

  const openResult = (testId) => {
    window.open(
      `/test-result/null/${testId}`,
      "View Result",
      "height=" + window.screen.height + ",width=" + window.screen.width
    );
  };

  return (
    <div className="test-details-container">
      {showLoader ? (
        <ILoader isShow={showLoader} loadingText="please wait.." />
      ) : (
        <>
          <div className="test-details-nav">
            <span className="test-details-nav-item">
              <span className="test-details-logout" onClick={logout}>
                Logout
              </span>
            </span>
          </div>
          <div className="unsat-logo-container">
            <img src={unsatLogo} alt="unsat" className="unsat-landing-logo" />
          </div>
          <span className="unsat-welcome-text">
            Welcome{" "}
            <span className="unsat-user-name">{jsonField1?.studentName}</span>
          </span>

          <div className="unsat-details-div-wrapper">
            <Row>
              <div className="col-1"></div>
              <div className="usr-details-wrapper col-md-7">
                {mode === "result" ? null : (
                  <div className="unsat-details-div">
                    <Row>
                      <div className="test-details-heading-3 fw-bold col-md-2 col-5 mb-2 text-left">
                        Class & Stream
                      </div>
                      <div className="test-details-description col-md-3 col-5 text-left">
                        : &nbsp;&nbsp;&nbsp;
                        {getValueForDropdown(
                          currentRegistrationForm,
                          "courses",
                          jsonField1,
                          "courseId"
                        )}
                      </div>
                      {jsonField1?.dob ? (
                        <>
                          <div className="test-details-heading-3 fw-bold col-md-2 col-5 text-left">
                            DOB{" "}
                          </div>
                          <div className="test-details-description col-md-3 col-5 text-left">
                            :&nbsp;&nbsp;&nbsp; {jsonField1?.dob}
                          </div>
                        </>
                      ) : null}
                    </Row>
                  </div>
                )}

                {testDetails ? (
                  testDetails?.map((testDetail, i) =>
                    mode === "result" ? (
                      <div className="unsat-landing-result-line">
                        View your result{" "}
                        <span
                          className="test-details-logout"
                          onClick={() => openResult(testDetail.id)}
                        >
                          here
                        </span>
                      </div>
                    ) : (
                      <React.Fragment key={i}>
                        <div className="unsat-details-div">
                          <Row>
                            <div className="test-details-heading-3 fw-bold col-md-2 col-5 text-left">
                              Exam Mode{" "}
                            </div>
                            <div className="test-details-description col-md-3 col-5 text-left">
                              :&nbsp;&nbsp;&nbsp; {testDetail.testType}
                            </div>
                            <div className="col-6">
                              {showRequestChange(testDetail.startDate) ? (
                                <span
                                  className=" btn btn-sm btn-success request-change-text"
                                  onClick={() =>
                                    handleRequestChange("EXAM MODE")
                                  }
                                >
                                  Request change
                                </span>
                              ) : (
                                false
                              )}
                            </div>
                          </Row>
                        </div>
                        <div className="unsat-details-div">
                          <Row>
                            <div className="test-details-heading-3 fw-bold col-md-2 col-5 text-left">
                              Exam Date
                            </div>
                            <div className="test-details-description col-md-3 col-5 text-left">
                              :&nbsp;&nbsp;&nbsp;
                              {testDetail.testDate || "will be communicated"}
                            </div>
                            <div className="col-6">
                              {showRequestChange(testDetail.startDate) ? (
                                <span
                                  className=" btn btn-sm btn-success request-change-text"
                                  onClick={() =>
                                    handleRequestChange("TEST DATE")
                                  }
                                >
                                  Request change
                                </span>
                              ) : null}
                            </div>
                          </Row>
                        </div>

                        <div className="unsat-details-div">
                          <Row>
                            <div className="test-details-heading-3 fw-bold col-md-2 col-5 text-left">
                              Time Slot
                            </div>
                            <div className="test-details-description col-md-3 col-5 text-left">
                              :&nbsp;&nbsp;&nbsp;
                              {!testDetail.startDate ||
                              testDetail.startDate === "--"
                                ? "will be communicated"
                                : `${testDetail.startDate.slice(
                                    8
                                  )}-${testDetail.endDate?.slice(8)}`}
                            </div>
                            <div className="col-6">
                              {showRequestChange(testDetail.startDate) ? (
                                <span
                                  className="btn btn-sm btn-success request-change-text"
                                  onClick={() =>
                                    handleRequestChange("TIME SLOT")
                                  }
                                >
                                  Request change
                                </span>
                              ) : null}
                            </div>
                          </Row>
                          {(!showRequestChange(testDetail.startDate) &&
                            testDetail.testType === "ONLINE") ||
                          mode === "result" ? (
                            <button
                              onClick={() =>
                                testDetail.status === "Launch" ||
                                testDetail.status === "View Result" ||
                                mode === "result"
                                  ? testDetail.status === "Launch"
                                    ? openTest(testDetail.id)
                                    : openResult(testDetail.id)
                                  : null
                              }
                              className="btn btn-sm btn-primary unsat-test-button"
                            >
                              {mode === "result" ? "Result" : testDetail.status}
                            </button>
                          ) : null}
                        </div>
                      </React.Fragment>
                    )
                  )
                ) : (
                  <React.Fragment>
                    <div className="unsat-details-div">
                      <Row>
                        <div className="test-details-heading-3 fw-bold col-md-2 col-5 text-left">
                          Exam Mode{" "}
                        </div>
                        <div className="test-details-description col-md-3 col-5 text-left">
                          :&nbsp;&nbsp;&nbsp; will be communicated
                        </div>
                      </Row>
                    </div>
                    <div className="unsat-details-div">
                      <Row>
                        <div className="test-details-heading-3 fw-bold col-md-2 col-5 text-left">
                          Exam Date
                        </div>
                        <div className="test-details-description col-md-3 col-5 text-left">
                          :&nbsp;&nbsp;&nbsp;will be communicated
                        </div>
                      </Row>
                    </div>

                    <div className="unsat-details-div">
                      <Row>
                        <div className="test-details-heading-3 fw-bold col-md-2 col-5 text-left">
                          Time Slot
                        </div>
                        <div className="test-details-description col-md-3 col-5 text-left">
                          :&nbsp;&nbsp;&nbsp;will be communicated
                        </div>
                      </Row>
                    </div>
                  </React.Fragment>
                )}
                <div className="class-list col-12">
                  <div className="syllabus-icon">
                    <div className="unsat-syllabus">
                      <img src={syllabus} onClick={openSyllabus} />
                      <span className="" onClick={openSyllabus}>
                        Syllabus
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="unsat-syllabus-text col-3">
                <img src={trophy} />
              </div>
              <div className="col-1"></div>
            </Row>
          </div>
        </>
      )}
      {showMailSentBox ? (
        <div className="unsat-notification">
          Your request for changes in the exam has been noted. Someone from
          Unacademy team will soon get in touch with you to assist you further.
        </div>
      ) : null}
    </div>
  );
};

export default UnsatLanding;
